import { render } from "./TextKR.vue?vue&type=template&id=188de490&scoped=true"
import script from "./TextKR.vue?vue&type=script&lang=js"
export * from "./TextKR.vue?vue&type=script&lang=js"

import "./TextKR.vue?vue&type=style&index=0&id=188de490&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-188de490"

export default script